import '@vfde-brix/feedback/dist/styles.css';
1
import { createFeedbackComponent } from '@vfde-brix/feedback';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/core';

const elements = document.getElementsByClassName('brix-feedback');

for (let i = 0, x = elements.length; i < x; i += 1) {

    // traversing one up to get the container element
    const containerElement = elements[i].parentElement;

    createFeedbackComponent(containerElement, NO_PATTERN_BUSINESS_LOGIC);

}
